export { StudyService } from './lib/study.service';
export * from './lib/studies-data-access-study.module';
